import { apiErrorToToast } from "@/lib/utils";
import { submitQuiz } from "@/requests/questionnaries/submit-quiz.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";

export const useSubmitQuizMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitQuiz,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "companies",
          variables.companyId,
          "quiz",
          variables.quizId,
          "details",
        ],
      });

      toast.success("Cuestionario enviado", {
        description: "Sus respuestas serán evaluadas pronto.",
      });
    },
  });
};
